import Header from "src/shared/components/Header/Header";

import EditProductContainer from "../containers/CreateEditProduct/EditProduct";

const EditProduct = () => (
  <>
    <Header hideSearchBar />
    <EditProductContainer />
  </>
);

export default EditProduct;
